var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8594 0.88501C8.21937 0.88501 5.70937 1.94501 3.85938 3.74501V2.88501C3.85938 2.33501 3.40937 1.88501 2.85938 1.88501C2.30938 1.88501 1.85938 2.33501 1.85938 2.88501V6.88501C1.85938 7.43501 2.30938 7.88501 2.85938 7.88501H5.85938C6.40938 7.88501 6.85938 7.43501 6.85938 6.88501C6.85938 6.33501 6.40938 5.88501 5.85938 5.88501H4.61938C6.12938 4.01501 8.41937 2.88501 10.8594 2.88501C15.2694 2.88501 18.8594 6.47501 18.8594 10.885C18.8594 15.295 15.2694 18.885 10.8594 18.885C6.44938 18.885 2.85938 15.295 2.85938 10.885C2.85938 10.335 2.40937 9.88501 1.85938 9.88501C1.30937 9.88501 0.859375 10.335 0.859375 10.885C0.859375 16.395 5.34937 20.885 10.8594 20.885C16.3694 20.885 20.8594 16.395 20.8594 10.885C20.8594 5.37501 16.3694 0.88501 10.8594 0.88501Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8594 5.88501C10.3094 5.88501 9.85938 6.33501 9.85938 6.88501V10.885C9.85938 11.215 10.0294 11.535 10.3094 11.715L13.3094 13.715C13.4794 13.825 13.6694 13.885 13.8594 13.885C14.1794 13.885 14.4994 13.725 14.6894 13.435C14.9994 12.975 14.8694 12.355 14.4094 12.045L11.8594 10.345V6.88501C11.8594 6.33501 11.4094 5.88501 10.8594 5.88501Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetTimeline);
export default __webpack_public_path__ + "static/media/reset-timeline.fb583940738d30bb3edf002c9cd5439c.svg";
export { ForwardRef as ReactComponent };